import { gql } from "@apollo/client";

const INVITE_TEAM_MEMBER = gql`
  query sendInviteToSignupAndTeamUp(
    $user: Int!
    $email: String!
    $teamName: String
    $acceptUrl: String!
    $declineUrl: String!
    $platformId: Int!
  ) {
    sendInviteToSignupAndTeamUp(
      user: $user
      email: $email
      teamName: $teamName
      acceptUrl: $acceptUrl
      declineUrl: $declineUrl
      platformId: $platformId
    ) {
      message
      success
    }
  }
`;

export default INVITE_TEAM_MEMBER;
